import { render, staticRenderFns } from "./social.vue?vue&type=template&id=8fda9a66&"
import script from "./social.vue?vue&type=script&lang=js&"
export * from "./social.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports